import React from "react";
import Controls from "../controls/control";
import { Link } from "react-router-dom";

export default function TableOuterLabel({ btnText, to }) {
  return (
    <div className="w-full flex">
      <Link to={to} className="ml-auto">
        <Controls.Button text={btnText} className="btn" />
      </Link>
    </div>
  );
}
